// opervex-frontend/src/Opervex/Accounting/FiscalPeriod.js

class FiscalPeriod {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  async create(data) {
    return this.#_api.post("/Accounting/FiscalPeriod/", data);
  }

  async update(id, data) {
    return this.#_api.put("/Accounting/FiscalPeriod/" + id, data);
  }

  async findId(id) {
    return await this.#_api.get("/Accounting/FiscalPeriod/" + id);
  }

  async findAll() {
    return await this.#_api.get("/Accounting/FiscalPeriod");
  }

  async schema() {
    return [
      {
        key: "period",
        label: "Período",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "startDate",
        label: "Data início",
        type: "date",
        visible: true,
        hidden: false,
      },
      {
        key: "endDate",
        label: "Data fim",
        type: "date",
        visible: true,
        hidden: false,
      },
      {
        key: "movement",
        label: "Movimentação",
        type: "boolean",
        visible: true,
        hidden: false,
      },
      {
        key: "closed",
        label: "Fechado",
        type: "boolean",
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default FiscalPeriod;
